export default __webpack_public_path__ + "static/board-a68ac3a4a7392bec5870cf0c78adfb93.jpg";